var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "groupOrderForm",
    staticClass: "overlay-dialog",
    attrs: { tag: "form", novalidate: "" },
    on: {
      submit: function($event) {
        $event.preventDefault()
        return _vm.onGroupOrderSubmit.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _c("h2", {
              staticClass: "overlay-dialog__title",
              domProps: { innerHTML: _vm._s(_vm.title) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "overlay-dialog__text" }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: {
                name: "name",
                rules: "required",
                tag: "div",
                customMessages: { required: _vm.$t("forms.errors.fieldEmpty") }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      var invalid = ref.invalid
                      var validated = ref.validated
                      return [
                        _c("FormInput", {
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("forms.labels.name"),
                            label: _vm.$t("forms.labels.name"),
                            name: "name",
                            error: errors.length > 0,
                            disabled: _vm.loading,
                            required: ""
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name"
                          }
                        }),
                        _vm._v(" "),
                        invalid && validated
                          ? _c("span", {
                              staticClass: "input-error",
                              domProps: { innerHTML: _vm._s(errors[0]) }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overlay-dialog__buttons" },
              [
                _c("Button", {
                  attrs: {
                    level: "tertiary",
                    type: "button",
                    text: _vm.$t("orderbox.groupOrder.cancelButton"),
                    disabled: _vm.loading,
                    arrow: "",
                    reverse: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$emit("cancel:grouporder")
                    }
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "primary",
                    type: "submit",
                    text: _vm.buttonText,
                    disabled: _vm.loading
                  }
                })
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }